import { Message, messageBannerFunctions, MessageTypes } from '@nhl/nhl-react-ui/lib/MessageBanner';

import screenerAPI from 'media-base-ui/utils/screenerAPI';
import actionCreators from './actionCreators';

const requestScreenerAccess = () => async dispatch => {
    dispatch(actionCreators.requestScreenerAccess());

    try {
        await screenerAPI.putScreenerAccessRequest();

        dispatch(actionCreators.screenerAccessResponse(true, []));
        messageBannerFunctions.dispatchMessage(new Message('Request sent successfully. Requests are reviewed as they come in. Please check back in a few days.',
            MessageTypes.SUCCESS));
    } catch (error) {
        dispatch(actionCreators.screenerAccessResponse(false, [error]));
        messageBannerFunctions.dispatchMessage(new Message(`An error occurred while submitting your request: ${error}`,
            MessageTypes.ERROR));
    }
};

export default {
    requestScreenerAccess
};
